import type { ValuePromiseMedia } from '../types'

// Per-card media + expanded color, keyed by id (merged with i18n copy in
// ValuePromiseSection). expandedBgClass is a full literal so Tailwind emits it.
export interface ValuePromiseCardMedia {
  media: ValuePromiseMedia
  expandedBgClass: string
}

const IMAGE_BASE = 'https://static.masterclass.com'

export const VALUE_PROMISE_MEDIA: Record<string, ValuePromiseCardMedia> = {
  becomeLeader: {
    media: {
      kind: 'image',
      imageUrl: `${IMAGE_BASE}/mcx-landing-feature-1.png`,
    },
    expandedBgClass: 'bg-edu-brand-green',
  },
  aiAdvantage: {
    media: { kind: 'video', videoUuid: '3a288d22-87d5-4429-93b5-418cdf404434' },
    expandedBgClass: 'bg-edu-brand-orange',
  },
  relationships: {
    media: {
      kind: 'image',
      imageUrl: `${IMAGE_BASE}/mcx-landing-feature-3.png`,
    },
    expandedBgClass: 'bg-edu-brand-blue',
  },
  aiTutor: {
    media: {
      kind: 'image',
      imageUrl: `${IMAGE_BASE}/mcx-landing-feature-4.png`,
    },
    expandedBgClass: 'bg-edu-brand-light-blue',
  },
}
